{
  "name": "@ns/authorise-subscription-card-use-feedback",
  "version": "1.0.0",
  "description": "Received feedback about using the requested subscription card for payments",
  "inputs": {
    "subscriptionId": {
      "type": "string"
    },
    "paymentMethodId": {
      "type": "string"
    },
    "feedback": {
      "type": "string"
    }
  },
  "outcomes": {
    "complete": {}
  }
}
